/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WalletDetailsInput } from './WalletDetailsInput';
import {
    WalletDetailsInputFromJSON,
    WalletDetailsInputFromJSONTyped,
    WalletDetailsInputToJSON,
} from './WalletDetailsInput';

/**
 * 
 * @export
 * @interface AccountDetailsBatchInput
 */
export interface AccountDetailsBatchInput {
    /**
     * 
     * @type {Array<WalletDetailsInput>}
     * @memberof AccountDetailsBatchInput
     */
    accounts: Array<WalletDetailsInput>;
}

/**
 * Check if a given object implements the AccountDetailsBatchInput interface.
 */
export function instanceOfAccountDetailsBatchInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accounts" in value;

    return isInstance;
}

export function AccountDetailsBatchInputFromJSON(json: any): AccountDetailsBatchInput {
    return AccountDetailsBatchInputFromJSONTyped(json, false);
}

export function AccountDetailsBatchInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDetailsBatchInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accounts': ((json['accounts'] as Array<any>).map(WalletDetailsInputFromJSON)),
    };
}

export function AccountDetailsBatchInputToJSON(value?: AccountDetailsBatchInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accounts': ((value.accounts as Array<any>).map(WalletDetailsInputToJSON)),
    };
}

